import React from "react";
import refreshIcon from "../../../assets/icon-refresh.svg";

import "./styles.css";

export const IconRefresh = () => {
  return <img className="icon-refresh" src={refreshIcon} alt="refresh-icon" />;
};
